import React from 'react';
import PropTypes from 'prop-types';
import Start from './components/Start';
import Center from './components/Center';
import End from './components/End';
import { st, classes } from './Footer.st.css.js';
import Divider from '../../../Divider';
import { buildChildrenObject } from '../../../common/utils/buildChildrenObject';
/** Layout footer component of 3 columns */
const Footer = ({ divider = false, className, children, dataHook }) => {
    const childrenObj = buildChildrenObject(children, {
        Start: React.createElement(Start, { key: "start" }),
        Center: React.createElement(Center, { key: "center" }),
        End: React.createElement(End, { key: "end" }),
    });
    return (React.createElement("div", { className: classes.root },
        divider && (React.createElement("div", { className: classes.divider },
            React.createElement(Divider, null))),
        React.createElement("div", { className: st(classes.container, className), children: Object.values(childrenObj), "data-hook": dataHook }, Object.values(childrenObj))));
};
Footer.displayName = 'Page.Footer';
Footer.propTypes = {
    /** Accepts following elements as child items:
    * - <Footer.Start />
    * - <Footer.Center />
    * - <Footer.End />
    * - <Page.Footer.Start />
    * - <Page.Footer.Center />
    * - <Page.Footer.End />
    <br/>
    Each of these areas accept any component as their child. */
    children: (props, propName) => {
        const childrenArr = React.Children.toArray(props[propName]);
        return childrenArr.reduce((err, child) => {
            if (!err &&
                child.type.displayName !== 'Page.Footer.Start' &&
                child.type.displayName !== 'Page.Footer.Center' &&
                child.type.displayName !== 'Page.Footer.End') {
                return new Error(`Invalid children provided, unknown child <${child.type.displayName || child.type} /> supplied`);
            }
            return err;
        }, false);
    },
    /** Applies a data-hook HTML attribute to be used in the tests */
    dataHook: PropTypes.string,
    /** Applies a CSS class to the component’s root element */
    className: PropTypes.string,
    /** Renders a full-width divider at the top of the footer */
    divider: PropTypes.bool,
};
Footer.Start = Start;
Footer.Center = Center;
Footer.End = End;
Footer.Start.displayName = 'Page.Footer.Start';
Footer.Center.displayName = 'Page.Footer.Center';
Footer.End.displayName = 'Page.Footer.End';
export default Footer;
//# sourceMappingURL=Footer.js.map